import { useNavigate } from "react-router-dom";
import SessionService from "../../../services/session-service";
import { UserRoles } from "../../../types/user-roles";
import ClientLoggedDashboard from "../../client-views/client-logged-dashboard/client-logged-dashboard";
import ClientOrders from "../../client-views/orders";
import OperatorLoggedDashboard from "../../operator-views/operator-logged-dashboard/operator-logged-dashboard";
import SubcontractorLoggedDashboard from "../../subcontactor-views/subcontractor-logged-dashboard/subcontractor-logged-dashboard";
import UnloggedDashboard from "../unlogged-dashboard";

const Home = () => {
  const user = SessionService.getUser();
  // const navigate = useNavigate();

  if (!user) {
    return <UnloggedDashboard />;
  } else {
    switch (user.typ_uzytkownika) {
      case UserRoles.CLIENT: {
        return <ClientLoggedDashboard />;
      }
      case UserRoles.OPERATOR: {
        return <OperatorLoggedDashboard />;
      }
      case UserRoles.SUBCONTRACTOR: {
        return <SubcontractorLoggedDashboard />;
      }
    }
  }
  return <></>;
};

export default Home;
